import DashboardLayout from '@/pages/Layout/DashboardLayout.vue'


import Link from '@/pages/Link.vue'

import Loans from '@/pages/Loans.vue'
import route404 from '@/pages/404.vue'

const routes = [
	{
		path: '/',
		component: DashboardLayout,
		redirect: '/404',
	},
	{
		path: '/tracking/:hash',
		component: Loans,
	},
	{
		path: '/link/:chat_id',
		component: Link,
	},
	{
		path: '/404',
		component: route404,
	},
	{
		path: '*',
		component: route404,
	}
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js